(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
    function fixAlts() {
      document.querySelectorAll('img:not([alt])').forEach(function (img) {
        var m = (img.getAttribute('src') || '').match(/\/([a-z]{2})\.png/);
        img.setAttribute('alt', m ? m[1].toUpperCase() : '');
      });
      fixDots();
    }
    function fixDot(btn) {
      if (!btn.hasAttribute('aria-selected')) return;
      var on = btn.getAttribute('aria-selected') === 'true';
      btn.removeAttribute('aria-selected');
      if (on) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current');
    }
    var dotObserver = null;
    function fixDots() {
      var dots = document.querySelectorAll('.slideshow-section .slideshow-control[ref="dots[]"]');
      dots.forEach(fixDot);
      if (dotObserver || !dots.length || !('MutationObserver' in window)) return;
      dotObserver = new MutationObserver(function (list) {
        list.forEach(function (m) { fixDot(m.target); });
      });
      dots.forEach(function (d) { dotObserver.observe(d, { attributes: true, attributeFilter: ['aria-selected'] }); });
    }
    function initLazyVideos() {
      var vids = [].slice.call(document.querySelectorAll('video[data-lazy-video]'));
      if (!vids.length) return;
      var conn = navigator.connection;
      if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      var interacted = false;
      function load(v) {
        if (v.dataset.loaded) return play(v);
        if (!interacted && v !== vids[0]) return;
        var src = mobile ? v.dataset.srcSm : v.dataset.srcLg;
        if (!src) return;
        v.dataset.loaded = '1';
        v.src = src;
        play(v);
      }
      function start() {
        if (!('IntersectionObserver' in window)) { load(vids[0]); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) load(e.target);
            else if (e.target.dataset.loaded) e.target.pause();
          });
        }, { threshold: 0.5 });
        vids.forEach(function (v) { io.observe(v); });
      }
      var evts = ['touchstart', 'pointerdown', 'keydown', 'wheel', 'scroll'];
      var started = false;
      var go = function () {
        if (started) return;
        started = true;
        start();
      };
      var onUser = function (e) {
        if (e.type === 'scroll' && window.scrollY < 10) return;
        interacted = true;
        evts.forEach(function (t) { window.removeEventListener(t, onUser, true); });
        go();
        vids.forEach(function (v) {
          var r = v.getBoundingClientRect();
          if (r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight) load(v);
        });
      };
      evts.forEach(function (t) { window.addEventListener(t, onUser, { capture: true, passive: true }); });
      var poster = document.querySelector('.slide__video-poster');
      var delay = mobile ? 800 : 300;
      if (!poster || poster.complete) setTimeout(go, delay);
      else {
        poster.addEventListener('load', function () { setTimeout(go, delay); }, { once: true });
        poster.addEventListener('error', function () { setTimeout(go, delay); }, { once: true });
      }
    }
    function init() {
      initLazyVideos();
      fixAlts();
      setTimeout(fixAlts, 3000);
      window.addEventListener('load', function () { setTimeout(fixAlts, 1000); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
